"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVendorTaxonomyKey = exports.VENDOR_TAXONOMY_KEYS = exports.ONBOARDABLE_VENDOR_TAXONOMY_KEYS = exports.SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS = exports.SEARCHABLE_VENDOR_TAXONOMY_KEYS = exports.VIDEOGRAPHERS_TAXONOMY_KEY = exports.VENUES_TAXONOMY_KEY = exports.VARIETY_ACTS_TAXONOMY_KEY = exports.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY = exports.SERVICE_STAFF_TAXONOMY_KEY = exports.RENTALS_DECOR_TAXONOMY_KEY = exports.PLANNERS_TAXONOMY_KEY = exports.PHOTOGRAPHERS_TAXONOMY_KEY = exports.PHOTOBOOTHS_TAXONOMY_KEY = exports.LIGHTING_AV_TAXONOMY_KEY = exports.JEWELERS_TAXONOMY_KEY = exports.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY = exports.HAIR_MAKEUP_TAXONOMY_KEY = exports.GIFT_FAVORS_TAXONOMY_KEY = exports.GENERAL_SERVICES_TAXONOMY_KEY = exports.FLORISTS_TAXONOMY_KEY = exports.CLOTHING_RENTALS_TAXONOMY_KEY = exports.CHILDCARE_SERVICES_TAXONOMY_KEY = exports.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY = exports.CATERING_TAXONOMY_KEY = exports.CAKES_DESSERTS_TAXONOMY_KEY = exports.BRIDAL_SHOPS_TAXONOMY_KEY = exports.BAR_SERVICES_TAXONOMY_KEY = exports.BANDS_DJS_TAXONOMY_KEY = exports.ALTERATIONS_PRESERVATION_TAXONOMY_KEY = exports.ACCOMMODATIONS_TAXONOMY_KEY = exports.ACCESSORIES_TAXONOMY_KEY = void 0;

require("core-js/modules/es.array.concat.js");

var ACCESSORIES_TAXONOMY_KEY = 'wedding-accessories';
exports.ACCESSORIES_TAXONOMY_KEY = ACCESSORIES_TAXONOMY_KEY;
var ACCOMMODATIONS_TAXONOMY_KEY = 'wedding-accommodations';
exports.ACCOMMODATIONS_TAXONOMY_KEY = ACCOMMODATIONS_TAXONOMY_KEY;
var ALTERATIONS_PRESERVATION_TAXONOMY_KEY = 'wedding-alterations-preservation';
exports.ALTERATIONS_PRESERVATION_TAXONOMY_KEY = ALTERATIONS_PRESERVATION_TAXONOMY_KEY;
var BANDS_DJS_TAXONOMY_KEY = 'wedding-bands-djs';
exports.BANDS_DJS_TAXONOMY_KEY = BANDS_DJS_TAXONOMY_KEY;
var BAR_SERVICES_TAXONOMY_KEY = 'wedding-bar-services';
exports.BAR_SERVICES_TAXONOMY_KEY = BAR_SERVICES_TAXONOMY_KEY;
var BRIDAL_SHOPS_TAXONOMY_KEY = 'wedding-bridal-shops';
exports.BRIDAL_SHOPS_TAXONOMY_KEY = BRIDAL_SHOPS_TAXONOMY_KEY;
var CAKES_DESSERTS_TAXONOMY_KEY = 'wedding-cakes-desserts';
exports.CAKES_DESSERTS_TAXONOMY_KEY = CAKES_DESSERTS_TAXONOMY_KEY;
var CATERING_TAXONOMY_KEY = 'wedding-catering';
exports.CATERING_TAXONOMY_KEY = CATERING_TAXONOMY_KEY;
var CELEBRANTS_OFFICIANTS_TAXONOMY_KEY = 'wedding-celebrants-officiants';
exports.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY = CELEBRANTS_OFFICIANTS_TAXONOMY_KEY;
var CHILDCARE_SERVICES_TAXONOMY_KEY = 'wedding-childcare-services';
exports.CHILDCARE_SERVICES_TAXONOMY_KEY = CHILDCARE_SERVICES_TAXONOMY_KEY;
var CLOTHING_RENTALS_TAXONOMY_KEY = 'wedding-clothing-rentals';
exports.CLOTHING_RENTALS_TAXONOMY_KEY = CLOTHING_RENTALS_TAXONOMY_KEY;
var FLORISTS_TAXONOMY_KEY = 'wedding-florists';
exports.FLORISTS_TAXONOMY_KEY = FLORISTS_TAXONOMY_KEY;
var GENERAL_SERVICES_TAXONOMY_KEY = 'wedding-general-services';
exports.GENERAL_SERVICES_TAXONOMY_KEY = GENERAL_SERVICES_TAXONOMY_KEY;
var GIFT_FAVORS_TAXONOMY_KEY = 'wedding-gift-favors';
exports.GIFT_FAVORS_TAXONOMY_KEY = GIFT_FAVORS_TAXONOMY_KEY;
var HAIR_MAKEUP_TAXONOMY_KEY = 'wedding-hair-makeup';
exports.HAIR_MAKEUP_TAXONOMY_KEY = HAIR_MAKEUP_TAXONOMY_KEY;
var INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY = 'wedding-invitations-calligraphy';
exports.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY = INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY;
var JEWELERS_TAXONOMY_KEY = 'wedding-jewelers';
exports.JEWELERS_TAXONOMY_KEY = JEWELERS_TAXONOMY_KEY;
var LIGHTING_AV_TAXONOMY_KEY = 'wedding-lighting-av';
exports.LIGHTING_AV_TAXONOMY_KEY = LIGHTING_AV_TAXONOMY_KEY;
var PHOTOBOOTHS_TAXONOMY_KEY = 'wedding-photobooths';
exports.PHOTOBOOTHS_TAXONOMY_KEY = PHOTOBOOTHS_TAXONOMY_KEY;
var PHOTOGRAPHERS_TAXONOMY_KEY = 'wedding-photographers';
exports.PHOTOGRAPHERS_TAXONOMY_KEY = PHOTOGRAPHERS_TAXONOMY_KEY;
var PLANNERS_TAXONOMY_KEY = 'wedding-planners';
exports.PLANNERS_TAXONOMY_KEY = PLANNERS_TAXONOMY_KEY;
var RENTALS_DECOR_TAXONOMY_KEY = 'wedding-tents-rentals-decor';
exports.RENTALS_DECOR_TAXONOMY_KEY = RENTALS_DECOR_TAXONOMY_KEY;
var SERVICE_STAFF_TAXONOMY_KEY = 'wedding-service-staff';
exports.SERVICE_STAFF_TAXONOMY_KEY = SERVICE_STAFF_TAXONOMY_KEY;
var TRANSPORTATION_PROVIDERS_TAXONOMY_KEY = 'wedding-transportation-providers';
exports.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY = TRANSPORTATION_PROVIDERS_TAXONOMY_KEY;
var VARIETY_ACTS_TAXONOMY_KEY = 'wedding-variety-acts';
exports.VARIETY_ACTS_TAXONOMY_KEY = VARIETY_ACTS_TAXONOMY_KEY;
var VENUES_TAXONOMY_KEY = 'wedding-venues';
exports.VENUES_TAXONOMY_KEY = VENUES_TAXONOMY_KEY;
var VIDEOGRAPHERS_TAXONOMY_KEY = 'wedding-videographers';
/**
 * Taxonomy key type for vendor categories that are searchable
 */

exports.VIDEOGRAPHERS_TAXONOMY_KEY = VIDEOGRAPHERS_TAXONOMY_KEY;

/**
 * List of vendor categories that are searchable, including subcategories
 */
var SEARCHABLE_VENDOR_TAXONOMY_KEYS = [VENUES_TAXONOMY_KEY, PHOTOGRAPHERS_TAXONOMY_KEY, VIDEOGRAPHERS_TAXONOMY_KEY, FLORISTS_TAXONOMY_KEY, CATERING_TAXONOMY_KEY, BAR_SERVICES_TAXONOMY_KEY, CAKES_DESSERTS_TAXONOMY_KEY, BANDS_DJS_TAXONOMY_KEY, HAIR_MAKEUP_TAXONOMY_KEY, PLANNERS_TAXONOMY_KEY];
/**
 * Ordered list of vendor categories that are searchable, not including subcategories
 *
 * Does not include bar services
 */

exports.SEARCHABLE_VENDOR_TAXONOMY_KEYS = SEARCHABLE_VENDOR_TAXONOMY_KEYS;
var SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS = [VENUES_TAXONOMY_KEY, PHOTOGRAPHERS_TAXONOMY_KEY, VIDEOGRAPHERS_TAXONOMY_KEY, FLORISTS_TAXONOMY_KEY, CATERING_TAXONOMY_KEY, CAKES_DESSERTS_TAXONOMY_KEY, BANDS_DJS_TAXONOMY_KEY, HAIR_MAKEUP_TAXONOMY_KEY, PLANNERS_TAXONOMY_KEY];
/**
 * Ordered list of vendor categories that are onboardable
 */

exports.SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS = SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS;
var ONBOARDABLE_VENDOR_TAXONOMY_KEYS = [HAIR_MAKEUP_TAXONOMY_KEY, CATERING_TAXONOMY_KEY, FLORISTS_TAXONOMY_KEY, CAKES_DESSERTS_TAXONOMY_KEY, BANDS_DJS_TAXONOMY_KEY, PHOTOGRAPHERS_TAXONOMY_KEY, PLANNERS_TAXONOMY_KEY, VENUES_TAXONOMY_KEY, VIDEOGRAPHERS_TAXONOMY_KEY];
/**
 * List of all vendor categories
 */

exports.ONBOARDABLE_VENDOR_TAXONOMY_KEYS = ONBOARDABLE_VENDOR_TAXONOMY_KEYS;
var VENDOR_TAXONOMY_KEYS = [].concat(SEARCHABLE_VENDOR_TAXONOMY_KEYS, [ACCESSORIES_TAXONOMY_KEY, ACCOMMODATIONS_TAXONOMY_KEY, ALTERATIONS_PRESERVATION_TAXONOMY_KEY, BRIDAL_SHOPS_TAXONOMY_KEY, CELEBRANTS_OFFICIANTS_TAXONOMY_KEY, CHILDCARE_SERVICES_TAXONOMY_KEY, CLOTHING_RENTALS_TAXONOMY_KEY, GENERAL_SERVICES_TAXONOMY_KEY, GIFT_FAVORS_TAXONOMY_KEY, INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY, JEWELERS_TAXONOMY_KEY, LIGHTING_AV_TAXONOMY_KEY, PHOTOBOOTHS_TAXONOMY_KEY, RENTALS_DECOR_TAXONOMY_KEY, SERVICE_STAFF_TAXONOMY_KEY, TRANSPORTATION_PROVIDERS_TAXONOMY_KEY, VARIETY_ACTS_TAXONOMY_KEY]);
/**
 * Determines whether the given string is a vendor taxonomy key
 */

exports.VENDOR_TAXONOMY_KEYS = VENDOR_TAXONOMY_KEYS;

var isVendorTaxonomyKey = function isVendorTaxonomyKey(s) {
  return SEARCHABLE_VENDOR_TAXONOMY_KEYS.some(function (typeKey) {
    return typeKey === s;
  });
};

exports.isVendorTaxonomyKey = isVendorTaxonomyKey;